module.exports = __webpack_public_path__ + "img/ew-icon_reset.a8bdeee2.svg";